/**
 * Фактическая награда главы обучения для конкретного игрока.
 *
 * Главы с наградой-фракцией (см. chapter.reward) для игрока, у которого эта
 * фракция уже открыта (куплена, выдана ранее или доступна через «все фракции»),
 * выдавали бы пустышку — таким игрокам отдается запасная награда
 * chapter.rewardIfFactionOwned (если она задана в конфиге главы).
 *
 * Один и тот же расчет нужен и серверу (что реально начислить при первом
 * прохождении, см. POST /api/users/me/tutorial-chapters/complete), и клиенту
 * (что показать в плашке главы до прохождения, см. TutorialMissionsPage) —
 * поэтому живет отдельно от обеих сторон.
 *
 * @param {Object} chapter - конфиг главы (см. src/configs/tutorial)
 * @param {Object} [options]
 * @param {string[]} [options.ownedFactionIds] - фракции, уже доступные игроку
 * @param {boolean} [options.isAllFactionsAvailable] - открыты все фракции
 * @returns {Object|null} награда или null, если у главы её нет
 */
export const getTutorialChapterReward = (chapter, {ownedFactionIds = [], isAllFactionsAvailable = false} = {}) => {
  const reward = chapter?.reward;
  if (!reward) {
    return null;
  }

  if (reward.type !== 'faction' || !chapter.rewardIfFactionOwned) {
    return reward;
  }

  const isFactionOwned = isAllFactionsAvailable || ownedFactionIds.includes(reward.factionId);

  return isFactionOwned ? chapter.rewardIfFactionOwned : reward;
};
